interface Location {
  end: number;
  start: number;
}

export interface Rule {
  content: string;
  name: string;
  location: Location;
}

export interface Ruleset {
  imports: Array<string>;
  rules: Array<Rule>;
  raw_file: string;
}

export interface IUploadYaraResponse {
  can_save: boolean;
  filename: string;
  id: string;
  message: string;
  ruleset_name: string;
  valid: boolean;
  online_source_id?: number;
  online_source_commit_id?: string;
  ruleset: Ruleset;
}

export interface IUploadYaraRulesetRequestItem {
  ruleset: string;
  id: string;
  content: string;
  online_source_id?: number;
  enabled: boolean;
  filename: string;
}

export interface IUploadYaraRulesetRequest {
  items: Array<IUploadYaraRulesetRequestItem>;
  uploadSessionId: string;
}

export interface CheckYaraRulesetValidityResponse {
  success: boolean;
  valid: boolean;
  errors: string[];
  field: string;
  message: string;
  warnings: string[];
}

export interface YaraRequest {
  content: string;
  enabled: boolean;
  name: string;
  ticloud?: boolean;
}

export interface IUseUpdateYaraRulesetRequestData {
  ruleset: URLSearchParams;
  id: number;
}
